<template>
  <div>
    <head-nav-bar title="封房" :fixed="true" />
    <div class="mt-header-nav">
      <van-field
        label="房号"
        placeholder="请输入房号"
        v-model="form.roomNo"
        disabled
      />
      <!-- <form-select
        label="封房原因"
        valueKey="Text"
        :required="true"
        v-model="form.reason"
        :columns="repairReasons"
      ></form-select> -->
      <van-field label="封房日期" disabled>
        <template slot="input">
          <DateRangePicker
            :min="min"
            :max="max"
            :value.sync="form.daterange"
            @change="(data, status) => handleDateRange(data, status)"
          ></DateRangePicker>
        </template>
      </van-field>
      <van-field
        v-model="form.reason"
        rows="1"
        autosize
        label="原因"
        type="textarea"
        placeholder="请输入封房原因"
      />
      <div class="sure-btn">
        <van-button type="info" size="large" @click="onSubmit">
          确认
        </van-button>
      </div>
    </div>
    <van-popup
      v-model="visible.showResult"
      close-icon-position="top-left"
      position="top"
      closeable
      @close="onClose"
      :style="{ height: '100%' }"
    >
      <result state="success" title="操作成功" :desc="desc" />
    </van-popup>
  </div>
</template>

<script>
import DateRangePicker from "@/components/date-range-picker/DateRangePicker.vue";
// import formSelect from "@/components/form-select";
import { Field, Button, Notify, ActionSheet, Popup, Icon } from "vant";
import { getSelectData } from "@/api/common.js";
import { mapState } from "vuex";
import { ls } from "@/utils/cache.js";
import roomApi from "@/api/room.js";
import Result from "@/components/result";
import moment from "moment";
export default {
  data() {
    return {
      visible: {
        showResult: false,
      },
      form: {
        roomNo: "",
        reason: "",
        remark: "",
        daterange: [],
      },
      repairReasons: [],
      min: "",
      max: "",
      defaultValue: [],
      roomInfo: {},
      desc: "",
    };
  },
  components: {
    [Field.name]: Field,
    [Button.name]: Button,
    [ActionSheet.name]: ActionSheet,
    [Notify.name]: Notify,
    [Popup.name]: Popup,
    [Icon.name]: Icon,
    DateRangePicker,
    Result,
    // formSelect,
  },
  computed: {
    ...mapState({
      user: state => state.user.info,
    }),
  },
  created() {
    this.min = this.user.AccountDate;
    this.max = moment(this.user.AccountDate)
      .add(1, "year")
      .format("YYYY-MM-DD");
    this.form.daterange = [
      this.user.AccountDate,
      moment(this.user.AccountDate)
        .add(1, "d")
        .format("YYYY-MM-DD"),
    ];
    this.getRepairReason();
    this.roomInfo = ls.get("current_room_info");
    this.form.roomNo = this.roomInfo.room.No;
  },
  methods: {
    handleDateRange(data, status) {
      if (data[0].valueOf() >= data[1].valueOf() && status == "start") {
        const end1 = moment(data[0])
          .add(1, "d")
          .format("YYYY-MM-DD");
        this.form.daterange = [data[0], end1];
      }
    },
    onSelect(item) {
      this.form.reason = item.name;
    },
    getRepairReason() {
      getSelectData({ Types: "RepairReason" }).then(res => {
        this.repairReasons = res.Data.RepairReason.map(v => {
          v.name = v.Text;
          return v;
        });
      });
    },
    onClose() {
      this.$router.push({ name: this.roomInfo.url });
    },
    onSubmit() {
      if (!this.form.reason || (this.form.reason && !this.form.reason.trim())) {
        Notify("请填写封房原因！");
        return;
      }
      if (!this.form.daterange[0] || !this.form.daterange[1]) {
        Notify("请选择封房日期！");
        return;
      }
      let start = moment(this.form.daterange[0]).format("YYYY-MM-DD");
      let end = moment(this.form.daterange[1]).format("YYYY-MM-DD");
      if (start == end) {
        end = moment(end)
          .add(1, "d")
          .format("YYYY-MM-DD");
      }
      const params = {
        RoomId: [this.roomInfo.room.Id],
        RoomNo: [this.roomInfo.room.No],
        BeginTime: start,
        EndTime: end,
        Reason: this.form.reason,
        Remark: this.form.remark,
        HandlerId: this.user.OperatorId,
        HandlerName: this.user.OperatorName,
      };
      roomApi.setLockBegin(params).then(res => {
        this.desc = res.Message;
        this.visible.showResult = true;
      });
    },
  },
};
</script>
<style lang="less">
.sure-btn {
  margin: 0.26667rem 0.42667rem;
}
</style>
